import React, { Component } from 'react';
import PopUp from './popup.js';

export default class WalletAddress extends Component {

  render() {

    var address = window.address;
    const data = this.props.data;

    var copy = function () {

        var copyText = document.querySelector("#address");
        copyText.setAttribute("type", "");
        copyText.select();
        document.execCommand("copy");
        copyText.setAttribute("type", "hidden");
        PopUp.prototype.show(data.addressCopied);
      };

    return (
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h2 class="header-title m-t-0 m-b-30">{data.walletAddress}</h2>
                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <p>{address}</p>
                            <input id="address" value={address} type="hidden"/>
                            <button type="button" onClick={copy} class="btn btn-blue waves-effect w-md waves-light m-b-5">{data.copy}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/wallet_address.js